import {
  FullNormalizedItem,
  NormalizedDataItems,
} from '@wix/editor-platform-host-integration-apis';

const sortByIndex = (a: FullNormalizedItem, b: FullNormalizedItem) =>
  a.index - b.index;

const mapDataByKeys = <T extends Record<string, T[string]>>(
  data: T,
  predicate: (data: T[string]) => T[string],
): T =>
  Object.fromEntries(
    Object.keys(data).map((key) => [key, predicate(data[key])]),
  ) as T;

export const sortNormalizedItems = (
  normalizedDataItems: NormalizedDataItems,
): NormalizedDataItems => {
  const { sectionsWithItems, notInSectionItems } = normalizedDataItems;

  return {
    ...normalizedDataItems,

    sectionsWithItems: mapDataByKeys(sectionsWithItems, (sectionByKey) => ({
      ...sectionByKey,

      unCategorizedItems: [...sectionByKey.unCategorizedItems].sort(
        sortByIndex,
      ),

      categoriesWithItems: mapDataByKeys(
        sectionByKey.categoriesWithItems,

        (categoryWithItems) => ({
          ...categoryWithItems,
          children: [...categoryWithItems.children].sort(sortByIndex),
        }),
      ),
    })),

    notInSectionItems: {
      ...notInSectionItems,

      unCategorizedItems: [...notInSectionItems.unCategorizedItems].sort(
        sortByIndex,
      ),

      categoriesWithItems: mapDataByKeys(
        notInSectionItems.categoriesWithItems,

        (nonInSectionCategoriesWithItems) => ({
          ...nonInSectionCategoriesWithItems,
          children: [...nonInSectionCategoriesWithItems.children].sort(
            sortByIndex,
          ),
        }),
      ),
    },
  };
};
